const CUSTOMER_SUCCESS_STATISTICS = {
  CUSTOMER_SUCCESS_HEADER_TITLE: 'رضایت مشتری',
  CUSTOMER_SUCCESS_HEADER_DESC:
    'در این بخش، آمار کلی امتیازاتی که توسط مشتریان داده شده را می‌توانید ببینید.',
  CUSTOMER_SUCCESS_STAT_CARD_AVERAGE_SCORE_TITLE: 'میانگین امتیازها',
  CUSTOMER_SUCCESS_STAT_CARD_AVERAGE_SCORE_COUNT_TITLE:
    'میانگین امتیاز ها ( از 1 تا 4 ) ',
  CUSTOMER_SUCCESS_STAT_CARD_SUBMITED_SCORES_TITLE: 'تعداد امتیازهای ثبت‌ شده',
  CUSTOMER_SUCCESS_STAT_CARD_SUBMITED_SCORES_COUNT_TITLE: 'امتیاز های ثبت شده',
  CUSTOMER_SUCCESS_STAT_CARD_SATISFACTION_SCORE_TITLE: 'درصد رضایت مشتریان',
  CUSTOMER_SUCCESS_STAT_CARD_SATISFACTION_SCORE_COUNT_TITLE: 'درصد رضایت',
  CUSTOMER_SUCCESS_STAT_CARD_HAPPY_CUSTOMERS_TITLE: 'درصد مشتریان خوشحال (😍)',
  CUSTOMER_SUCCESS_STAT_CARD_HAPPY_CUSTOMERS_COUNT_TITLE: 'درصد مشتریان',
  CUSTOMER_SUCCESS_STAT_CARD_ANGRY_CUSTOMERS_TITLE: 'درصد مشتریان عصبانی (😡)',
  CUSTOMER_SUCCESS_STAT_CARD_ANGRY_CUSTOMERS_COUNT_TITLE: 'درصد مشتریان',
  CUSTOMER_SUCCESS_CHART_HEADER_TITLE: 'امتیاز به تفکیک اپراتور ها',
  CUSTOMER_SUCCESS_CHART_NO_DATA: 'داده ای برای نمایش وجود ندارد !',
  CUSTOMER_SUCCESS_CHART_RATE_1_LEGEND: ' (امتیاز 1)😍',
  CUSTOMER_SUCCESS_CHART_RATE_2_LEGEND: ' (امتیاز 2)😀',
  CUSTOMER_SUCCESS_CHART_RATE_3_LEGEND: ' (امتیاز 3)😔',
  CUSTOMER_SUCCESS_CHART_RATE_4_LEGEND: ' (امتیاز 4)😡',
  CUSTOMER_SUCCESS_EXPORT_BTN_LABEL: 'خروجی csv',
};

export default CUSTOMER_SUCCESS_STATISTICS;
